
// import Notice from "~/components/home/notice.vue";
import BannerTop from "@/components/home/bannerTop.vue";
import CommonTitle from "@/components/home/commonTitle.vue";
export default {
  name:"sirius",
  components: {
    CommonTitle,
    BannerTop,
    // Notices
  },
  data() {
    return {
      bannerUrl:require("@/static/images/coreTechnology/banner.png"),
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/coreTechnology/sirius/sirius1.png`),
          imgStyle:{
            width:"386px",
            height:"620px"
          }
        }
      ],
    }
  },
  computed: {
    contentList () {
      return this.$t('technology.sirius.contentList')
    },
  },
}
